const convertNoteInitLiquidationPref = (notesLedger, liquidationPreference) => {
  const notes = notesLedger ?? [];
  const values = notes.map(
    ({ expected_shares, conversion_price_per_share }) =>
      (expected_shares ?? 0) * (conversion_price_per_share ?? 0) * liquidationPreference
  );
  return values.reduce((acc, val) => acc + val, 0);
};
export default convertNoteInitLiquidationPref;
